module.exports = __webpack_public_path__ + "static/media/LI4.5d9c669e.jpg";